import latest from "../docs-content/latest.json";

const KEY = "scadox.docs.changelogSeen";

/** Per-browser convenience only: storage can throw (private mode, blocked
 *  site data), and then we simply show no dot rather than a permanent one. */
function storageWorks(): boolean {
  try { localStorage.getItem(KEY); return true; } catch { return false; }
}

/** Slug of the newest change-log entry this browser has opened. */
export function getLastSeen(): string | null {
  try { return localStorage.getItem(KEY); } catch { return null; }
}

export function markChangelogSeen(latestSlug: string): void {
  try { localStorage.setItem(KEY, latestSlug); } catch { /* per-viewer nicety; ignore */ }
}

/** Compares slugs, not dates: a second entry published the same day must
 *  still raise the dot -- that is how a Stricter notice gets seen. */
export function hasUnseen(latestSlug: string | undefined): boolean {
  if (!latestSlug || !storageWorks()) return false;
  return getLastSeen() !== latestSlug;
}

/** Reads build_portal_docs.py's latest.json (a few bytes, in the main bundle)
 *  rather than the full docs content, which stays in its lazy chunk. */
export function useChangelogUnseen(): boolean {
  return hasUnseen((latest as { slug?: string }).slug);
}
